import React from 'react'
import { Clock, RotateCcw, AlertCircle, Globe } from 'lucide-react'

const Problem: React.FC = () => {
  const problems = [
    {
      icon: Clock,
      title: "시간 낭비",
      description: "30분 영상, 핵심은 2분",
      color: "text-red-500"
    },
    {
      icon: RotateCcw,
      title: "알고리즘 함정",
      description: "늘 비슷한 추천 콘텐츠",
      color: "text-orange-500"
    },
    {
      icon: AlertCircle,
      title: "뒤늦은 발견",
      description: "이미 대세가 바뀌었다고?",
      color: "text-yellow-500"
    },
    {
      icon: Globe,
      title: "언어 장벽",
      description: "국외 커뮤니티는 영어라...",
      color: "text-blue-500"
    }
  ]

  return (
    <section className="py-20 bg-white">
      <div className="container-width section-padding">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            AI 정보, <span className="text-red-500">이래서 놓칩니다</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            바쁜 일상 속에서 정말 중요한 AI 트렌드를 놓치고 계시지 않나요?
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className="group p-8 bg-gray-50 rounded-2xl border border-gray-200 hover:border-gray-300 hover:shadow-lg transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-16 h-16 ${problem.color} bg-current/10 rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <problem.icon className={`w-8 h-8 ${problem.color}`} />
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {problem.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                "{problem.description}"
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-6">
            <AlertCircle className="w-8 h-8 text-red-500" />
          </div>
          <p className="text-lg text-gray-700 font-medium">
            이런 문제들로 인해 <strong className="text-red-500">정말 중요한 AI 혁신</strong>을 놓치고 있습니다
          </p>
        </div>
      </div>
    </section>
  )
}

export default Problem
